<template>
  <div class="v-cal">

    <header class="v-cal-header">
      <div class="v-cal-header__actions">
        <div class="actions-left">
          <button
            class="v-cal-button"
            v-if="showTodayButton"
            @click="goToToday"
            :class="{
              'v-cal-button--is-active':
                activeDate && activeDate.isSame(today, 'day')
            }"
          >
            {{ labels.today }}
          </button>
          <button
            :disabled="!isPrevAllowed"
            class="v-cal-button"
            @click="prev"
            v-html="labels.back"
          ></button>
          <button
            :disabled="!isNextAllowed"
            class="v-cal-button"
            @click="next"
            v-html="labels.next"
          ></button>
        </div>
        <div class="v-cal-header__title-bar">
          <h3 class="v-cal-header__title">{{ calendarTitle }}</h3>
        </div>
        <div class="actions-right">
          <button
            class="v-cal-button"
            v-for="view in availableViews"
            @click="switchView(view)"
            :class="{ 'v-cal-button--is-active': activeView === view }"
            :key="view"
          >
            {{ labels[view] | capitalizeFirstLetter }}
          </button>
        </div>
      </div>
      <!--      <div class="v-cal-header__title-bar">-->
      <!--        <h3 class="v-cal-header__title">{{ calendarTitle }}</h3>-->
      <!--      </div>-->
    </header>
    <component
      @event-clicked="eventClicked"
      :is="activeView"
      :class="'v-cal-content--' + activeView"
      v-bind="activeViewProps"
    ></component>
    <footer class="v-cal-footer"></footer>
  </div>
</template>

<script>
import Event from "../model/Event";

import config from "../utils/config";
import { defaultLabels, defaultViews } from "../utils/config";
import apiClientCreator from "../../../../../../helpers/api/request";

import { EventBus } from "./EventBus";

import moment from "moment";
import Month from "./views/Month";
import Week from "./views/Week";
import Day from "./views/Day";

import EventDialog from "./dialog";

export default {
  name: "VueScheduler",
  components: { Month, Week, Day },
  props: {
    events: {
      type: Array,
      default: () => []
    },
    estTime: {
      type: String
    },
    showTodayButton: {
      type: Boolean,
      default: () => config.showTodayButton
    },
    minDate: {
      type: [Date, Object],
      default: () => config.minDate
    },
    maxDate: {
      type: [Date, Object],
      default: () => config.maxDate
    },
    labels: {
      type: Object,
      default: () => config.labels,
      validator(value) {
        for (const labelKey in defaultLabels) {
          if (!value.hasOwnProperty(labelKey)) {
            return false;
          }
        }
        return true;
      }
    },
    timeRange: {
      type: Array,
      default: () => config.timeRange,
      validator(value) {
        if (
          value.length !== 2 ||
          value[0] > value[1] ||
          value[0] < 0 ||
          value[1] > 23
        ) {
          return false;
        }
        return true;
      }
    },
    availableViews: {
      type: Array,
      default: () => config.availableViews,
      validator(value) {
        const possible = defaultViews;
        let error = false;
        value.forEach(view => {
          if (possible.indexOf(view) === -1) {
            error = true;
          }
        });
        return !error;
      }
    },
    initialDate: {
      type: [Date, Object],
      default: () => config.initialDate
    },
    initialView: {
      type: String,
      default: () => config.initialView
    },
    use12: {
      type: Boolean,
      default: () => config.use12
    },
    showTimeMarker: {
      type: Boolean,
      default: () => config.showTimeMarker
    },
    eventDisplay: {
      type: [String, Function],
      default: () => config.eventDisplay
    },
    disableDialog: {
      type: Boolean,
      default: false
    },
    eventDialogConfig: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      today: moment(),
      activeView: "",
      activeDate: null
    };
  },
  mounted() {
    //  Initial setup
    this.activeView = this.initialView;
    this.activeDate = moment(this.initialDate);

    //  Bind events
    this.bindEvents();
  },
  beforeDestroy() {
    EventBus.$off("day-clicked");
    EventBus.$off("time-clicked");
    EventBus.$off("event-clicked");
  },
  methods: {
    openEventDialog(data) {
      this.$root.$emit("date_changed_from_calendar", data);
      if (this.activeView === "day") {
        if (data.task_id != undefined) {
          let { fields, ...config } = this.eventDialogConfig;
          if (data instanceof Date) {
            config.date = data;
          } else {
            config.date = data.date;
            config.startTime =
              data.time !== null ? moment(data.startTime, "HH:MM") : null;
            config.endTime =
              data.time !== null
                ? moment(data.endTime, "HH").add(15, "m")
                // ? moment(data.endTime, "HH").add(this.estTime, "m")
                : null;
            config.name = data.name;
            config.submitFunction = "changeEvent";
          }
          fields = [
            "changeEvent",
            {
              name: config.name,
              type: "textarea",
              label: "Content",
              disabled: true
            }
          ];
          EventDialog.show(config, fields).$on("event-clicked", event => {
            event.name = data.name;
            event.task_id = data.task_id;
            let fixedStartTime = moment(event.startTime)
              .year(moment(event.date).get("year"))
              .month(moment(event.date).get("month"))
              .date(moment(event.date).get("date"));
            let fixedEndTime = moment(event.endTime)
              .year(moment(event.date).get("year"))
              .month(moment(event.date).get("month"))
              .date(moment(event.date).get("date"));
            this.events.push(event);
            this.$emit("event-clicked", event);
            apiClientCreator(`tasks/update/date/${event.task_id}`).put("", {
              start_time: fixedStartTime,
              end_time: fixedEndTime
            });
          });
        } else if (data.task_id === undefined) {
          let { fields, ...config } = this.eventDialogConfig;

          if (data instanceof Date) {
            config.date = data;
          } else {
            config.date = data.date;
            config.startTime =
              data.time !== null ? moment(data.time, "HH:MM") : null;
            config.endTime =
              data.time !== null ? moment(data.time, "HH") : null;
            // config.startTime =  moment(data.date, 'HH:MM')
            // config.endTime =  null;
            config.submitFunction = "saveEvent";
          }
          fields = ["saveEvent"];
          EventDialog.show(config, fields).$on("event-created", event => {
            this.$root.$emit("time_changed_from_calendar", event);

            this.events.push(event._e);
            this.$emit("event-created", event._e);
          });
        }
      }
      this.activeView = "day";
      this.activeDate = moment(data.date);
    },
    bindEvents() {
      EventBus.$on("day-clicked", date => {
        this.$emit("day-clicked", date);
        this.openEventDialog(date);
      });
      EventBus.$on("time-clicked", data => {
        this.$emit("time-clicked", data);
        this.$root.$emit("time-clicked");
        let tempTimeObj = {};
        (tempTimeObj.date = data.date),
          (tempTimeObj.startTime = moment(data.date).add(data.time, "hours")),
          (tempTimeObj.endTime = moment(tempTimeObj.startTime).add(
            15,
                  // this.estTime,
            "minutes"
          ));

        this.$root.$emit("time_changed_from_calendar", tempTimeObj);
        // this.openEventDialog(data);
        this.events.push(tempTimeObj);
        this.$emit("event-created",tempTimeObj);
      });
      EventBus.$on("event-clicked", event => {
        this.$emit("event-clicked", event._e);
        this.openEventDialog(event);
      });
    },
    eventClicked() {
      EventBus.$emit("event-clicked", this.event);
    },
    goToToday() {
      this.activeDate = moment(this.today);
    },
    prev() {
      this.activeDate = moment(
        this.activeDate.subtract(1, this.activeView + "s")
      );
    },
    next() {
      this.activeDate = moment(this.activeDate.add(1, this.activeView + "s"));
    },
    switchView(view) {
      this.activeView = view;
    }
  },
  filters: {
    capitalizeFirstLetter(string) {
      return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
    }
  },
  watch: {
    initialDate() {
      this.activeDate = moment(this.initialDate);
    },
    initialView() {
      this.activeView = this.initialView;
    },
    activeDate() {
      this.$emit(this.activeView + "-changed", this.activeDate.toDate());
    },
    activeView() {
      this.$emit("view-changed", this.activeView);
    }
  },
  computed: {
    newEvents() {
      return this.events.map(e => {
        return new Event(e).bindGetter("displayText", this.eventDisplay);
      });
    },
    isPrevAllowed() {
      if (this.minDate) {
        const prevRef = moment(this.activeDate).subtract(
          1,
          this.activeView + "s"
        );
        return this.minDate.isSameOrBefore(prevRef, this.activeView);
      }
      return true;
    },
    isNextAllowed() {
      if (this.maxDate) {
        const afterRef = moment(this.activeDate).add(1, this.activeView + "s");
        return this.maxDate.isSameOrAfter(afterRef, this.activeView);
      }
      return true;
    },
    activeViewProps() {
      let props = {
        activeDate: this.activeDate,
        minDate: this.minDate,
        maxDate: this.maxDate,
        use12: this.use12,
        events: this.newEvents.filter(event => {
          return event.date.isSame(this.activeDate, this.activeView);
        })
      };

      if (this.activeView === "week" || this.activeView === "day") {
        props.allDayLabel = this.labels.all_day;
        props.timeRange = this.timeRange;
        props.showTimeMarker = this.showTimeMarker;
      }
      return props;
    },
    calendarTitle() {
      if (this.activeDate === null) return "";

      if (this.activeView === "month") {
        return this.activeDate.format("MMMM YYYY");
      }

      if (this.activeView === "week") {
        const weekStart = moment(this.activeDate).day(0);
        const weekEnd = moment(this.activeDate).day(6);
        return weekStart.format("MMM D") + " - " + weekEnd.format("MMM D");
      }

      if (this.activeView === "day") {
        return this.activeDate.format("dddd MMM D");
      }
      return true;
    }
  }
};
</script>

<style scoped></style>
